import { useMutation } from "@tanstack/react-query"
import { useTRPC } from "app/trpc-context"
import { usePostHog } from "posthog-js/react"

export const useLogout = () => {
  const trpc = useTRPC()
  const logoutMutation = useMutation(trpc.auth.logout.mutationOptions())
  const posthog = usePostHog()

  return async () => {
    await logoutMutation.mutateAsync()
    sessionStorage.clear()
    posthog.reset()
    window.location.href = "/login"
  }
}
